import {apiSlice} from "store/slices/apis/apiSlice";
export const authApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getUserInfo: builder.query({
            query: (req) => ({
                url: `account/user/info`,
            }),
        }),

    }),
});

export const {
    useLazyGetUserInfoQuery,
    useGetUserInfoQuery
} = authApiSlice;
